
import { useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/lib/supabase";
import { RefreshCw, Download } from "lucide-react";

const SocialMediaSync = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSyncPosts = async () => {
    setIsLoading(true);
    
    try {
      const { data, error } = await supabase.functions.invoke('fetch-social-posts');
      
      if (error) {
        throw error;
      }

      toast({
        title: "Success",
        description: `${data.posts_count} posts synced successfully`,
      });
    } catch (error) {
      console.error('Sync error:', error);
      toast({
        title: "Sync Failed",
        description: "Failed to sync social media posts. Please check your API credentials.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Download className="w-5 h-5" />
          Sync Social Media Posts
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <p className="text-sm text-gray-600">
            Automatically fetch the latest posts from your connected Instagram and Facebook accounts.
          </p>
          
          <div className="bg-blue-50 p-4 rounded-lg">
            <h4 className="font-medium text-blue-900 mb-2">Setup Required:</h4>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• Instagram Access Token</li>
              <li>• Facebook Access Token</li>
              <li>• Facebook Page ID</li>
            </ul>
            <p className="text-xs text-blue-700 mt-2">
              These credentials need to be configured in your Supabase edge function secrets.
            </p>
          </div>

          <Button 
            onClick={handleSyncPosts} 
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? (
              <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
            ) : (
              <Download className="w-4 h-4 mr-2" />
            )}
            {isLoading ? 'Syncing Posts...' : 'Sync Posts Now'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SocialMediaSync;
